import {
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    InputAdornment,
    OutlinedInput,
    styled,
    Switch
} from "@mui/material";
import {grey} from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import {ReactLassoSelect} from "react-lasso-select";
import LineSelect from "../lineSelect/lineSelect";

const StyledTextField = styled(OutlinedInput)(({theme, disabled}) => ({
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '& .MuiInputBase-input.Mui-disabled': {
        WebkitTextFillColor: 'rgba(0, 0, 0, 1)',  // Chrome
        color: 'rgba(0, 0, 0, 1)',                // fallback
        opacity: 1,                                // undo disabled opacity
    },
    backgroundColor: disabled ? undefined : '#f9f9f9',
    height: 40
}));

const CustomFormControlLabel = styled(FormControlLabel)(({theme}) => ({
    // Prevent the whole wrapper from dimming
    '&.Mui-disabled': {
        opacity: 1,
    },
    '&.MuiFormControlLabel-label': {
        WebkitTextFillColor: grey[700], // for Chrome
        color: grey[700],
    },
    // Force the label text to your theme's primary text color
    '&.Mui-disabled .MuiFormControlLabel-label': {
        color: grey[700],
        opacity: 1,
    },
    // Ensure the Switch itself stays at full opacity
    '&.MuiFormControlLabel-root	.Mui-disabled': {
        opacity: 1,
    },
    height: 40
}));

function CustomTextField({
    id,
    helperText,
    error = false,
    disabled = false,
    fullWidth = false,
    ...inputProps
}) {
    return (
        <FormControl
            variant="outlined"
            error={error}
            fullWidth={fullWidth}
        >
            <StyledTextField
                id={id}
                disabled={disabled}
                {...inputProps}
            />
            {helperText && (
                <FormHelperText>
                    {helperText}
                </FormHelperText>
            )}
        </FormControl>
    );
}

export default function DeviceSettingsField({
    fieldData,
    setEditField,
    alias,
    error,
    disabled,
    image,
    imageSize,
    setNotAligned
}) {
    // const [doubleCheck, setDoubleCheck] = useState('');
    // useEffect(() => {
    //     fieldData.type === 'text' && setNotAligned(fieldData.current !== doubleCheck);
    // }, [fieldData.current, doubleCheck]);
    setNotAligned(false);
    switch (fieldData.type) {
        case 'text':
            return <>
                <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                    <Typography variant="body1" color={grey[700]}>
                        {fieldData.display || alias}
                    </Typography>
                </Grid>
                <Grid size={8} sx={{display: 'flex', flexDirection: "column", alignItems: 'flex-start'}}>
                    <Grid container spacing={1} sx={{mt: 1}}>
                        {Object.entries(fieldData.value).map(([key, value]) => (
                            <Grid size={12}>
                                <CustomTextField
                                    name={key}
                                    disabled={disabled}
                                    type='text'
                                    id={key}
                                    // error={!disabled && (error || value !== doubleCheck)}
                                    startAdornment={<InputAdornment position="start">
                                        <span style={{color: '#404040'}}>{key}: </span>
                                    </InputAdornment>}
                                    onChange={(e) => setEditField((fields) => ({
                                        ...fields,
                                        [alias]: {
                                            ...fields[alias],
                                            value: {...fields[alias].value, [key]: String(e.target.value)}
                                        }
                                    }))}
                                    value={value === undefined ? '' : value}
                                    sx={{maxWidth: 350}}
                                />
                            </Grid>
                        ))}
                    </Grid>
                    {fieldData.helperText && (
                        <FormHelperText>
                            {fieldData.helperText}
                        </FormHelperText>
                    )}
                    {/*{!disabled &&*/}
                    {/*    <CustomTextField*/}
                    {/*        name={`${alias}-confirm`}*/}
                    {/*        disabled={disabled}*/}
                    {/*        type='text'*/}
                    {/*        id={`${alias}-confirm`}*/}
                    {/*        error={error || fieldData.current !== doubleCheck}*/}
                    {/*        onChange={(e) => setDoubleCheck(String(e.target.value))}*/}
                    {/*        value={doubleCheck}*/}
                    {/*        sx={{maxWidth: 350, mt: 1}}*/}
                    {/*        helperText={fieldData.current !== doubleCheck && 'please confirm your new settings'}*/}
                    {/*    />*/}
                    {/*}*/}
                </Grid>
            </>;
        case 'tracking':
            return <>
                <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                    <Typography variant="body1" color={grey[700]}
                                sx={{height: 40, display: 'flex', alignItems: 'center'}}>
                        {fieldData.display || alias}
                    </Typography>
                </Grid>
                <Grid size={8}>
                    <CustomFormControlLabel
                        control={<Switch/>}
                        name={alias}
                        id={alias}
                        label='Enabled'
                        labelPlacement='start'
                        disabled={disabled}
                        checked={Boolean(fieldData.enable)}
                        onChange={(e) => setEditField((fields) => ({
                            ...fields,
                            [e.target.name]: {...fields[e.target.name], enable: e.target.checked}
                        }))}
                    />
                </Grid>
                <Grid size={4}>
                </Grid>
                <Grid size={8} sx={{display: 'flex', alignItems: 'flex-start'}}>
                    <CustomTextField
                        disabled={disabled}
                        name={alias}
                        type='number'
                        id={alias}
                        error={error}
                        inputProps={{step: 1}}
                        onChange={(e) => setEditField((fields) => ({
                            ...fields,
                            [e.target.name]: {...fields[e.target.name], cycle: Number(e.target.value)}
                        }))}
                        helperText={fieldData.helperText}
                        value={fieldData.cycle === undefined ? '' : fieldData.cycle}
                        sx={{maxWidth: 350}}
                    />
                </Grid>
            </>;
        case 'int':
            return <>
                <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                    <Typography variant="body1" color={grey[700]}>
                        {fieldData.display || alias}
                    </Typography>
                </Grid>
                <Grid size={8}>
                    <CustomTextField
                        name={alias}
                        disabled={disabled}
                        type='number'
                        id={alias}
                        error={error || fieldData.current > fieldData.max || fieldData.current < fieldData.min}
                        helperText={`Max: ${fieldData.max}, Min: ${fieldData.min}`}
                        onChange={(e) => setEditField((fields) => ({
                            ...fields,
                            [e.target.name]: {...fields[e.target.name], current: Number(e.target.value)}
                        }))}
                        inputProps={{
                            step: 1, max: fieldData.max, min: fieldData.min
                        }}
                        value={fieldData.current === undefined ? '' : fieldData.current}
                        sx={{maxWidth: 350}}
                    />
                    {fieldData.helperText && (
                        <FormHelperText>
                            {fieldData.helperText}
                        </FormHelperText>
                    )}
                </Grid>
            </>;
        case 'switch':
            return <>
                <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                    <Typography variant="body1" color={grey[700]}>
                        {fieldData.display || alias}
                    </Typography>
                </Grid>
                <Grid size={8}>
                    <CustomFormControlLabel
                        control={<Switch/>}
                        name={alias}
                        id={alias}
                        label={null}
                        disabled={disabled}
                        checked={Boolean(fieldData.current)}
                        onChange={(e) => setEditField((fields) => ({
                            ...fields,
                            [e.target.name]: {...fields[e.target.name], current: e.target.checked}
                        }))}
                    >
                    </CustomFormControlLabel>
                    {fieldData.helperText && (
                        <FormHelperText>
                            {fieldData.helperText}
                        </FormHelperText>
                    )}
                </Grid>
            </>;
        case 'area':
            return <>
                {Object.keys(fieldData).includes('enable') && <>
                    <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Typography variant="body1" color={grey[700]}>
                            Enable {fieldData.display || alias}
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <CustomFormControlLabel
                            control={<Switch/>}
                            name={alias}
                            id={alias}
                            label={null}
                            disabled={disabled}
                            checked={Boolean(fieldData.enable)}
                            onChange={(e) => setEditField((fields) => ({
                                ...fields,
                                [e.target.name]: {...fields[e.target.name], enable: e.target.checked}
                            }))}
                        />
                    </Grid>
                </>}
                {Object.keys(fieldData).includes('name') && <>
                    <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Typography variant="body1" color={grey[700]}>
                            {fieldData.display || alias} Name
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <CustomTextField
                            name={alias}
                            type='text'
                            id={alias}
                            disabled={disabled}
                            error={error}
                            onChange={(e) => setEditField((fields) => ({
                                ...fields,
                                [e.target.name]: {...fields[e.target.name], name: e.target.value}
                            }))}
                            value={fieldData.name || ''}
                            sx={{maxWidth: 350}}
                        />
                    </Grid>
                </>}
                {Object.keys(fieldData).includes('direction') && <>
                    <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Typography variant="body1" color={grey[700]}>
                            {fieldData.display || alias} Direction
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <CustomTextField
                            name={alias}
                            type='text'
                            disabled={disabled}
                            id={alias}
                            error={error}
                            onChange={(e) => setEditField((fields) => ({
                                ...fields,
                                [e.target.name]: {...fields[e.target.name], direction: e.target.value}
                            }))}

                            value={fieldData.direction || ''}
                            sx={{maxWidth: 350}}
                        />
                    </Grid>
                </>}
                {(!image && Object.keys(fieldData).includes('reference_coordinate_system')) && <>
                    <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Typography variant="body1" color={grey[700]}>
                            {fieldData.display || alias} Reference Coordinate
                        </Typography>
                    </Grid>
                    {typeof fieldData.reference_coordinate_system === 'string' ?
                        <Grid size={8}>
                            <Typography>
                                Width x Height: {fieldData.reference_coordinate_system}
                            </Typography>
                        </Grid> :
                        <Grid size={8}>
                            <Grid container spacing={1}>
                                <Grid size={3}>
                                    <Typography>
                                        Width: {fieldData.reference_coordinate_system.width}
                                    </Typography>
                                </Grid>
                                <Grid size={3}>
                                    <Typography>
                                        Height: {fieldData.reference_coordinate_system.height}
                                    </Typography>
                                </Grid>
                                <Grid size={6}/>
                            </Grid>
                        </Grid>}
                </>
                }
                <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                    <Typography variant="body1" color={grey[700]}>
                        {fieldData.display || alias} Points
                    </Typography>
                </Grid>
                <Grid size={8}>
                    {fieldData.helperText && (
                        <FormHelperText>
                            {fieldData.helperText}
                        </FormHelperText>
                    )}
                    <Grid container spacing={1} sx={{mt: 1}}>
                        {image ?
                            (fieldData.format === 'quadrangle' ?
                                    <ReactLassoSelect
                                        value={fieldData.points.map((point) => ({
                                            x: Math.round(point.x / fieldData.reference_coordinate_system.width * imageSize.width),
                                            y: Math.round(point.y / fieldData.reference_coordinate_system.height * imageSize.height)
                                        }))}
                                        src={image}
                                        onChange={(value) => setEditField((fields) => ({
                                            ...fields,
                                            [alias]: {
                                                ...fields[alias],
                                                points: value.map((point) => ({
                                                    x: Math.round(point.x / imageSize.width * fieldData.reference_coordinate_system.width),
                                                    y: Math.round(point.y / imageSize.height * fieldData.reference_coordinate_system.height)
                                                }))
                                            }
                                        }))}
                                        // onComplete={() => setLassoClosed(true)}
                                        disabled={disabled}
                                        style={{maxWidth: "100%"}}
                                        imageStyle={{maxWidth: "100%"}}
                                        // onImageLoad={handleLoad}
                                    /> :
                                    <LineSelect
                                        src={image}
                                        alt={'image'}
                                        value={fieldData.points.map((point) => ({
                                            x: Math.round(point.x / fieldData.reference_coordinate_system.width * imageSize.width),
                                            y: Math.round(point.y / fieldData.reference_coordinate_system.height * imageSize.height)
                                        }))}
                                        key='line-select'
                                        onChange={(value) => setEditField((fields) => ({
                                            ...fields,
                                            [alias]: {
                                                ...fields[alias],
                                                points: value.map((point) => ({
                                                    x: Math.round(point.x / imageSize.width * fieldData.reference_coordinate_system.width),
                                                    y: Math.round(point.y / imageSize.height * fieldData.reference_coordinate_system.height)
                                                }))
                                            }
                                        }))}
                                        disabled={disabled}
                                        style={{maxWidth: "100%"}}
                                        imageStyle={{maxWidth: "100%"}}
                                        // onImageLoad={handleLoad}

                                    />
                            ) :
                            fieldData.points.map((point, index) => (
                                <>
                                    <Grid size={3}>
                                        <CustomTextField
                                            name='x'
                                            type='number'
                                            id='x'
                                            disabled={disabled}
                                            error={error}
                                            inputProps={{step: 1}}
                                            startAdornment={<InputAdornment position="start">
                                                <span style={{color: '#404040'}}>x: </span>
                                            </InputAdornment>}
                                            onChange={(e) => setEditField((fields) => ({
                                                ...fields,
                                                [alias]: {
                                                    ...fields[alias],
                                                    points: fields[alias].points.map((item, itemIdx) =>
                                                        index === itemIdx ? {...item, x: Number(e.target.value)} : item)
                                                }
                                            }))}
                                            value={point.x === undefined ? '' : point.x}
                                            sx={{maxWidth: 350}}
                                        />
                                    </Grid>
                                    <Grid size={3}>
                                        <CustomTextField
                                            name='y'
                                            type='number'
                                            id='y'
                                            error={error}
                                            disabled={disabled}
                                            inputProps={{step: 1}}
                                            startAdornment={<InputAdornment position="start">
                                                <span style={{color: '#404040'}}>y: </span>
                                            </InputAdornment>}
                                            onChange={(e) => setEditField((fields) => ({
                                                ...fields,
                                                [alias]: {
                                                    ...fields[alias],
                                                    points: fields[alias].points.map((item, itemIdx) =>
                                                        index === itemIdx ? {...item, y: Number(e.target.value)} : item)
                                                }
                                            }))}
                                            value={point.y === undefined ? '' : point.y}
                                            sx={{maxWidth: 350}}
                                        />
                                    </Grid>
                                    <Grid size={6}/>
                                    <Grid size={7}>
                                        <Divider/>
                                    </Grid>
                                    <Grid size={5}/>
                                </>
                            ))
                        }
                    </Grid>
                </Grid>
            </>;
    }
}